import * as React from "react";
import { FC } from "react";
import { IUpdates } from "../Map/mapProvider";
import { Feature } from "ol";
import { SelectedStatus } from "../Map/enums";

export interface IAttributeTableProps {
    graphic: Feature;
    onZoomToGraphic: (graphic: Feature) => void;
    onUpdateAttributes: (graphic: Feature, updates: IUpdates) => void;
}
export const DemoAttributeTable: FC<IAttributeTableProps> = (props) => {
    return (
        <table>
            <tbody>
                <tr>
                    <th></th>
                    <th>
                        <div>
                            <button onClick={() => props.onZoomToGraphic(props.graphic)}>Zoom To</button>
                        </div>
                        <div>
                            <button
                                onClick={() =>
                                    props.onUpdateAttributes(props.graphic, { visited: 0, like: 0, route: 0 })
                                }
                            >
                                Default
                            </button>
                            <button onClick={() => props.onUpdateAttributes(props.graphic, { visited: 1 })}>
                                Visited
                            </button>
                            <button onClick={() => props.onUpdateAttributes(props.graphic, { like: 1 })}>Like</button>
                            <button onClick={() => props.onUpdateAttributes(props.graphic, { route: 1 })}>Route</button>
                        </div>
                        <div>
                            <button
                                onClick={() =>
                                    props.onUpdateAttributes(props.graphic, { selectedState: SelectedStatus.Default })
                                }
                            >
                                Default
                            </button>
                            <button
                                onClick={() =>
                                    props.onUpdateAttributes(props.graphic, { selectedState: SelectedStatus.Selected })
                                }
                            >
                                Selected
                            </button>
                        </div>
                    </th>
                </tr>
                <tr>
                    <th>OBJECTID</th>
                    <td>
                        <div>{props.graphic.values_.OBJECTID}</div>
                    </td>
                </tr>
                <tr>
                    <th>PLACENAME</th>
                    <td>
                        <div>{props.graphic.values_.PLACENAME}</div>
                    </td>
                </tr>
                <tr>
                    <th>PLACEDESCRIPTION</th>
                    <td>
                        <div>
                            {props.graphic.values_.PLACEDESCRIPTION &&
                                props.graphic.values_.PLACEDESCRIPTION.slice(0, 80)}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>PLACESUBTYPE</th>
                    <td>
                        <div>{props.graphic.values_.PLACESUBTYPE}</div>
                    </td>
                </tr>
                <tr>
                    <th>KEYWORDS</th>
                    <td>
                        <div>{props.graphic.values_.KEYWORDS}</div>
                    </td>
                </tr>
                <tr>
                    <th>TOURISMTYPESSTR</th>
                    <td>
                        <div>{props.graphic.values_.TOURISMTYPESSTR}</div>
                    </td>
                </tr>
                <tr>
                    <th>SELECTED / VISITED / LIKE / ROUTE</th>
                    <td>
                        <div>
                            {props.graphic.values_.SELECTED +
                                " / " +
                                props.graphic.values_.VISITED +
                                " / " +
                                props.graphic.values_.LIKE +
                                " / " +
                                props.graphic.values_.ROUTE}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>FEATURETYPE</th>
                    <td>
                        <div>{props.graphic.values_.FEATURETYPE}</div>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
